module.exports = __webpack_public_path__ + "img/logo.44372652.svg";